
// Product page unlock cutom logic

  (function () {
    var wrapper = document.querySelector('.onpulse-tabs-section');
    if (!wrapper) return;

    var tabs = wrapper.querySelectorAll('.onpulse-tab');
    var panels = wrapper.querySelectorAll('.onpulse-panel');
    var mobileBreakpoint = 640;
    var resizeTimer;
    var lastMode = null;

    function getMode() {
      return window.innerWidth <= mobileBreakpoint ? 'mobile' : 'desktop';
    }

    function getSrcForMode(img, mode) {
      return mode === 'mobile'
        ? img.getAttribute('data-mobile-src')
        : img.getAttribute('data-desktop-src');
    }

    function preloadImage(src) {
      if (!src) return;

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
    }

    function preloadAllTabImages() {
      var images = wrapper.querySelectorAll('.onpulse-panel-image');

      images.forEach(function (img) {
        preloadImage(img.getAttribute('data-mobile-src'));
        preloadImage(img.getAttribute('data-desktop-src'));
      });
    }

    function applyResponsiveImageSources(force) {
      var mode = getMode();
      if (!force && mode === lastMode) return;

      var images = wrapper.querySelectorAll('.onpulse-panel-image');

      images.forEach(function (img) {
        var newSrc = getSrcForMode(img, mode);

        if (newSrc && img.getAttribute('src') !== newSrc) {
          img.setAttribute('src', newSrc);
        }
      });

      lastMode = mode;
    }

    function activateTab(tab) {
      var idx = tab.getAttribute('data-tab');

      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });

      panels.forEach(function (p) {
        p.classList.remove('is-active');
      });

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');

      var targetPanel = wrapper.querySelector('.onpulse-panel[data-panel="' + idx + '"]');

      if (targetPanel) {
        var targetImg = targetPanel.querySelector('.onpulse-panel-image');
        var mode = getMode();

        if (targetImg) {
          var correctSrc = getSrcForMode(targetImg, mode);

          if (correctSrc && targetImg.getAttribute('src') !== correctSrc) {
            targetImg.setAttribute('src', correctSrc);
          }
        }

        targetPanel.classList.add('is-active');
      }
    }

    preloadAllTabImages();
    applyResponsiveImageSources(true);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(this);
      });

      tab.addEventListener('mouseenter', function () {
        var idx = this.getAttribute('data-tab');
        var panel = wrapper.querySelector('.onpulse-panel[data-panel="' + idx + '"]');
        if (!panel) return;

        var img = panel.querySelector('.onpulse-panel-image');
        if (!img) return;

        preloadImage(img.getAttribute('data-mobile-src'));
        preloadImage(img.getAttribute('data-desktop-src'));
      });

      tab.addEventListener('touchstart', function () {
        var idx = this.getAttribute('data-tab');
        var panel = wrapper.querySelector('.onpulse-panel[data-panel="' + idx + '"]');
        if (!panel) return;

        var img = panel.querySelector('.onpulse-panel-image');
        if (!img) return;

        preloadImage(img.getAttribute('data-mobile-src'));
        preloadImage(img.getAttribute('data-desktop-src'));
      }, { passive: true });

      tab.addEventListener('keydown', function (e) {
        var currentIndex = Array.prototype.indexOf.call(tabs, this);
        var nextIndex;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          nextIndex = (currentIndex + 1) % tabs.length;
          tabs[nextIndex].focus();
          activateTab(tabs[nextIndex]);
        }

        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          activateTab(tabs[nextIndex]);
        }

        if (e.key === 'Home') {
          e.preventDefault();
          tabs[0].focus();
          activateTab(tabs[0]);
        }

        if (e.key === 'End') {
          e.preventDefault();
          tabs[tabs.length - 1].focus();
          activateTab(tabs[tabs.length - 1]);
        }
      });
    });

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        applyResponsiveImageSources(false);
      }, 120);
    });
  })();
